<template>
  <div class="settings">
    <FixedHeader :showSearch="windowWidth >= 700">
      <b-button
        class="back-button"
        type="is-text"
        icon-left="arrow-left"
        size="is-medium"
        @click="goTo()"
      ></b-button>
      <a @click="goTo()">
        <img
          class="logo"
          alt="Pinwall logo"
          :src="
            require(`../assets/img/${
              darkMode ? 'pinwall-logo-new-dark.svg' : 'pinwall-logo-new.svg'
            }`)
          "
        />
      </a>
    </FixedHeader>
    <div class="content">
      <Edit :title="'Settings'" v-if="tenant" :item="tenant" />
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FixedHeader from "../components/FixedHeader";
import Footer from "@/components/Footer";
import Edit from "../components/tenant/Edit";
import { goTo } from "../mixins/goTo.js";

export default {
  name: "Settings",
  components: {
    FixedHeader,
    Edit,
    Footer
  },
  mixins: [goTo],
  computed: {
    ...mapGetters(["user", "tenant", "selectedSpace", "darkMode"])
  },
  mounted() {
    if (
      !this.user ||
      (!this.tenant.editable && !this.selectedSpace.tenantEditable)
    ) {
      this.goTo();
    }
  }
};
</script>
